import { IDisplay as IDisplayElectron } from '../fetchFromElectron';
import { IDisplay as IDisplayExtension } from '../fetchFromExtension';

const DEFAULT_PPI = 96;
const CM_TO_INCH = 0.393701;

const calculateScreenSize = (
  display: IDisplayExtension | IDisplayElectron,
): number => {
  let widthInch = 0;
  let heightInch = 0;
  let dpiX = DEFAULT_PPI;
  let dpiY = DEFAULT_PPI;

  if ('dpiX' in display && 'dpiY' in display && display.dpiX && display.dpiY) {
    dpiX = display.dpiX;
    dpiY = display.dpiY;
  }

  if (
    'heightInCm' in display &&
    'widthInCm' in display &&
    display.heightInCm &&
    display.widthInCm
  ) {
    heightInch = display.heightInCm * CM_TO_INCH;
    widthInch = display.widthInCm * CM_TO_INCH;
  } else if (
    'heightInPx' in display &&
    'widthInPx' in display &&
    display.heightInPx &&
    display.widthInPx
  ) {
    heightInch = display.heightInPx / dpiY;
    widthInch = display.widthInPx / dpiX;
  } else if (
    'height' in display &&
    'width' in display &&
    display.height &&
    display.width
  ) {
    heightInch = display.height / dpiY;
    widthInch = display.width / dpiX;
  }

  const diagonalInches = Math.sqrt(heightInch ** 2 + widthInch ** 2);
  const diagonalInchesRounded = Math.round(diagonalInches * 10) / 10;
  return diagonalInchesRounded;
};

export default calculateScreenSize;
